import { useState } from "react";
import Sidebar from "../Common/Sidebar";
import { Menu } from "lucide-react";
import SystemSettings from "../Components/SystemSettings";
import { useNavigate } from "react-router-dom";
import StatsCards from "../Components/StatsCards";
import ProcessPerformance from "../Components/ProcessPerformance";
import PoliciesByDayChart from "../Components/PoliciesByDayChart";
import BottleneckChart from "../Components/BottleneckChart";
import ProcessEfficiencyChart from "../Components/ProcessEfficiencyChart";
import ProcessCapabilityMatrix from "../Components/ProcessCapabilityMatrix";
import TopRecommendations from "../Components/TopRecommendation"; 
import { SimulatorProvider } from "./SimulatorStore";

export default function Simulator() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const onSidebarClick = (val: any) => {
    setSidebarOpen(val);
  };
  return (
    <SimulatorProvider>
      <div className="flex min-h-screen bg-gray-100">
        <Sidebar pagename="simulator" onSidebarClick={() => onSidebarClick(false)} sidebarOpen={sidebarOpen} />
        {/* Main Content */}
        <main className="flex-1 h-screen overflow-y-auto p-4 md:p-8 ">
          {/* Page Header (mobile only) */}
          <div className="mb-4 md:mb-6">
            <div className="flex items-center justify-between md:hidden">
              <h1 className="text-xl font-bold text-gray-900">Simulator</h1>
              <button onClick={() => onSidebarClick(true)}>
                <Menu className="w-6 h-6 text-gray-700" />
              </button>
            </div>
          </div>

          {/* System Settings Section */}
          <SystemSettings />

          {/* StatsCards section */}
          <div className="mt-4 mb-6">
            <StatsCards />
          </div>

          {/* Charts Section */}
          <div className="grid grid-flow-cols lg:grid-cols-3 gap-6 mb-6">
            <div className="row-span-3 ">
              <ProcessPerformance />
            </div>

            <div className="col-span-2 space-y-4">
              <PoliciesByDayChart />
              <BottleneckChart />
              <ProcessEfficiencyChart />
              <ProcessCapabilityMatrix />
            </div>

            {/* Top Recommendations */}
            <div className="col-span-3">
              <TopRecommendations />
            </div>
            
          </div>
        </main>
      </div>
    </SimulatorProvider>
  );
}
